import { ReactElement } from 'react';

import { Box } from 'components/Box';
import { StaffTools } from 'components/Staff/StaffTools';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { useCurrentUserIsStaff } from 'modules/main/store/hooks';
import { gutterWidth } from 'theme';

type Props = {
  content: CmsApiPage;
};

export function LayoutStaffTools({ content }: Props): ReactElement | null {
  const isStaff = useCurrentUserIsStaff();
  if (!isStaff) return null;

  return (
    <Box
      position="absolute"
      top="100%"
      right={gutterWidth / 2}
      mt={[gutterWidth / 2, null, null, gutterWidth + 18]}
    >
      <StaffTools content={content} />
    </Box>
  );
}
